import { skipToken, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useHardwareTypes(corporationId: string | undefined) {
    return useQuery({
        queryKey: ['hardware-types', corporationId],

        queryFn: corporationId
            ? () => sdClient.getCorporationHardwareTypes({ corporationId })
            : skipToken,
    });
}
